// extracted by mini-css-extract-plugin
export default {"save-btn":"styles_save-btn__Hwea7"};